import { useIsPaywallCustomizationPhase2 } from "@/react/hooks/useIsPaywallCustomizationPhase2";
import type { BadgeProperty } from "@/react/types/PaywallCustomization";
import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import { Badge } from "./Badge";

export const Badges = () => {
  const { paywallCustomization } = usePaywallCheckoutContext();
  const isEnabled = useIsPaywallCustomizationPhase2();

  const { enabled: isBadgeEnabled, badges } =
    paywallCustomization?.badge_properties || {
      enabled: false,
      badges: [],
    };

  if (!isBadgeEnabled || !isEnabled) {
    return null;
  }

  return (
    <div className="flex flex-row flex-wrap gap-2">
      {badges.map((badge: BadgeProperty) => (
        <Badge key={badge.id} {...badge} />
      ))}
    </div>
  );
};
